import { useState } from "react";
import { useProductTranslations } from "../../hooks/TranslationHooks";
import classNames from "classnames";
import {
  Button,
  Col,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Row
} from "reactstrap";
import FormattedPrice from "../FormattedPrice";
import { multiply } from "../../utils/NumberUtils";
import Icon from "../Icon";
import "./style.scss";

const QuantityInput = ({
  id,
  className,
  style,
  value: initValue = 1,
  valueCallback,
  stock,
  salesUnit,
  price,
  currency
}) => {
  const tp = useProductTranslations();
  const stockInt = parseInt(stock) || 999;
  const [value, setValue] = useState(initValue);

  const setAmount = e => {
    if (e.target.value === "") {
      setValue("");
      valueCallback?.(0);
      return;
    }
    let newValue = parseInt(e?.target?.value);
    if (isNaN(newValue) || newValue < 1) {
      newValue = 1;
    }
    setValue(newValue);
    valueCallback?.(newValue);
  };

  const total = multiply(value === "" ? 0 : value, price);
  return (
    <div
      id={id}
      className={classNames("quantity-input", className)}
      style={style}
    >
      <Row>
        <Col sm={5} md={5}>
          <FormGroup>
            <InputGroupText className={"quantity-input-label"}>
              {tp("quantity")}
            </InputGroupText>
            <InputGroup>
              <Button
                onClick={() => {
                  const newV = value > 0 && value !== "" ? value - 1 : value;
                  setValue(newV);
                  valueCallback?.(newV);
                  return newV;
                }}
                disabled={value <= 1}
                className={"minus button"}
                color="bjelin-darkgrey"
              >
                <Icon name="minus" />
              </Button>
              <div className={"input-wrapper"}>
                <Input
                  type={"number"}
                  value={value}
                  onChange={setAmount}
                  className={"quantity-input-field"}
                />
                <InputGroupText className={"quantity-input-unit"}>
                  {tp("sales_unit." + salesUnit)}
                </InputGroupText>
              </div>
              <Button
                onClick={() => {
                  const newV = (value === "" ? 0 : value) + 1;
                  setValue(newV);
                  valueCallback?.(newV);
                  return newV;
                }}
                disabled={value >= stockInt}
                className={"plus button"}
                color="bjelin-darkgrey"
              >
                <Icon name="plus" />
              </Button>
            </InputGroup>
          </FormGroup>
        </Col>
      </Row>
      <div
        style={{
          marginTop: "0.4rem",
          marginBottom: "0.4rem",
          fontSize: "1.25em",
          letterSpacing: "-0.02em"
        }}
      >
        <strong>
          {tp("sum")}: <FormattedPrice price={total} currency={currency} />
        </strong>
      </div>
    </div>
  );
};

export default QuantityInput;
